import { SVG } from '../svg';
import { IconProps } from '../types';

export function ChevronLeftIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props}>
      <path d="m15 18-6-6 6-6" />
    </SVG>
  );
}
